import React from 'react';
import { Flex, Select, HStack, Text, IconButton, Switch, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { Minus, Plus } from 'lucide-react';
import { ARABIC_FONTS, ARABIC_SIZES } from '../../hooks/useQuranSettings';

/**
 * Reciter, translation, Arabic font and size pickers for the reading pages.
 */
const ReaderSettings = ({ settings, showReciter = true, showTranslationPicker = true }) => {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const { update } = settings;

  return (
    <Flex
      bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="xl" p={3} mb={6}
      gap={3} wrap="wrap" align="center"
    >
      {showReciter && (
        <Select size="sm" maxW="200px" aria-label="Reciter" value={settings.reciterId}
          onChange={(e) => update({ reciterId: e.target.value })}>
          {settings.reciters.map((r) => <option key={r._id} value={String(r._id)}>{r.reciter_name}</option>)}
        </Select>
      )}
      {showTranslationPicker && settings.translations.length > 0 && (
        <Select size="sm" maxW="240px" aria-label="Translation" value={settings.translationId}
          onChange={(e) => update({ translationId: e.target.value })}>
          {settings.translations.map((t) => <option key={t._id} value={String(t._id)}>{t.translator}</option>)}
        </Select>
      )}
      <Select size="sm" maxW="220px" aria-label="Arabic font" value={settings.fontKey}
        onChange={(e) => update({ fontKey: e.target.value })}>
        {ARABIC_FONTS.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
      </Select>
      <HStack spacing={1}>
        <Tooltip label="Smaller Arabic text">
          <IconButton size="sm" variant="ghost" aria-label="Smaller Arabic text" icon={<Minus size={14} />}
            isDisabled={settings.sizeIndex <= 0} onClick={() => update({ sizeIndex: settings.sizeIndex - 1 })} />
        </Tooltip>
        <Text fontSize="sm" fontFamily={settings.fontFamily}>أ</Text>
        <Tooltip label="Larger Arabic text">
          <IconButton size="sm" variant="ghost" aria-label="Larger Arabic text" icon={<Plus size={14} />}
            isDisabled={settings.sizeIndex >= ARABIC_SIZES.length - 1} onClick={() => update({ sizeIndex: settings.sizeIndex + 1 })} />
        </Tooltip>
      </HStack>
      {showTranslationPicker && (
        <HStack ml={{ md: 'auto' }}>
          <Text fontSize="sm">Translation</Text>
          <Switch size="sm" colorScheme="teal" isChecked={settings.showTranslation}
            onChange={(e) => update({ showTranslation: e.target.checked })} />
        </HStack>
      )}
    </Flex>
  );
};

export default ReaderSettings;
